import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Alert, { AlertType } from '../../../../Shared/components/Alert';
import LoadingSpinner from '../../../../Shared/components/LoadingSpinner';
import DataService from '../../../services/DataService';
import { ZdsContentReveal, ZdsDivider, ZdsIcon } from '@zig-design-system/ui-components-react';
import FormatUtility, { Formats } from '../../../../Shared/Utility/FormatUtility';
import { UnitTypes } from '../../../interfaces/Unit';
import Translation from '../../../../Shared/components/Translation';
import ContactList from './ContactList';
import Contact from './Contact';
import SpecificationList from './SpecificationList';
import ResourcesList from './ResourcesList';
import Reaction from './Reaction';
import PageTitle from '../../../../Shared/Utility/PageTitle';
import UnitFormatService from '../../../services/UnitFormatService';
import { renderToString } from 'react-dom/server';
import BackButton from '../../Generic/Detail/BackButton';
import Map from '../../Generic/Detail/Map';
import { RootContext } from '../../../../Context/RootContext';
import ShareThisPage from '../../../../Shared/components/ShareThisPage';
import ShareThisPageConfigurationService from '../../../../Shared/services/ShareThisPageConfigurationService';
import HousingCosts from './HousingCosts';
import Images from '../../Generic/Detail/Images';
const Detail = () => {
    const { id } = useParams();
    const [unit, setUnit] = useState();
    const [errorStatus, setErrorStatus] = useState();
    const pageSettings = useContext(RootContext);
    const [shareThisPageConfiguration, setShareThisPageConfiguration] = useState(null);
    useEffect(() => {
        if (!shareThisPageConfiguration) {
            ShareThisPageConfigurationService.get().then(setShareThisPageConfiguration);
        }
    });
    useEffect(() => {
        window.scrollTo({ top: 0 });
        DataService.getUnitById(id)
            .then((unitResponse) => {
            setUnit(unitResponse);
        })
            .catch((err) => {
            setErrorStatus(err.status);
            setUnit(null);
        });
    }, [id]);
    useEffect(() => {
        if (unit === null || unit === void 0 ? void 0 : unit.name) {
            PageTitle.set(unit.name);
        }
    }, [unit]);
    if (unit === undefined) {
        return React.createElement(LoadingSpinner, null);
    }
    else if (!unit) {
        if (errorStatus === 404) {
            return (React.createElement(Alert, { title: "t(tx_zigrealestate.error.unitNotFound.title)", message: "t(tx_zigrealestate.error.unitNotFound.message)", type: AlertType.error }));
        }
        else {
            return (React.createElement(Alert, { title: "t(tx_zigrealestate.error.unitCallError.title)", message: "t(tx_zigrealestate.error.unitCallError.message)", type: AlertType.error }));
        }
    }
    const yesNoField = (value) => {
        if (value === 0) {
            return React.createElement(Translation, { item: "tx_zigrealestate.no" });
        }
        if (value === 1) {
            return React.createElement(Translation, { item: "tx_zigrealestate.yes" });
        }
        return null;
    };
    const parseTernaryBoolean = (value) => {
        const yesNoMaybe = String(value);
        return yesNoMaybe === '0' ? false : yesNoMaybe === '1' ? true : null;
    };
    const priceHeaderBuy = () => {
        return (React.createElement("p", null,
            React.createElement("span", { className: "zds-headline-md" },
                FormatUtility.format(unit.sellingPrice, Formats.buyPrice),
                ' ',
                unit.buyerPaysCosts === 1 ? ' k.k.' : '')));
    };
    const priceHeaderRent = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement("span", { className: "zds-headline-xxl" }, FormatUtility.format(unit.netRent, Formats.currency)),
                ' ',
                unit.rentCondition),
            React.createElement("div", { className: "zds-margin-top-1 zds-color-grey" },
                React.createElement(Translation, { item: "tx_zigrealestate.details.totalRent" }),
                ' ',
                FormatUtility.format(unit.grossRent, Formats.currency),
                " ",
                unit.rentCondition)));
    };
    const showHousingCosts = pageSettings.pluginContext.housingCostsUnitTypes.some((unitType) => UnitTypes[unitType] === unit.type);
    if (unit) {
        return (React.createElement("div", { className: "zds-row zds-gap-y-0" },
            unit.images && unit.images.length > 0 && React.createElement(Images, { images: unit.images }),
            React.createElement("div", { className: "default-content" },
                React.createElement("div", { className: "zds-margin-bottom-6" },
                    React.createElement("h1", { className: "zds-headline-xxl" }, unit.street
                        ? unit.street +
                            ' ' +
                            UnitFormatService.formatHouseNumberAndAddition(unit.houseNumber, unit.houseNumberAddition)
                        : unit.name),
                    React.createElement("div", { className: "zds-color-grey zds-margin-top-1 zds-body-lg real-estate__top-features--separator" },
                        unit.postalCode && React.createElement("span", null, unit.postalCode),
                        unit.city && React.createElement("span", null, unit.city),
                        unit.quarter && React.createElement("span", null, unit.quarter)),
                    React.createElement("div", { className: "zds-margin-top-4 md:zds-flex" },
                        unit.bedrooms.length > 0 && (React.createElement("span", { className: "zds-color-grey zds-body-lg zds-margin-right-12 real-estate__top-features" },
                            React.createElement(ZdsIcon, { class: "zds-margin-right-2", name: "bed", slot: "icon", size: "md" }),
                            unit.bedrooms.length,
                            "\u00A0",
                            unit.bedrooms.length == 1 && (React.createElement(Translation, { item: "tx_zigrealestate.details.bedroom" })),
                            unit.bedrooms.length > 1 && (React.createElement(Translation, { item: "tx_zigrealestate.details.bedrooms" })))),
                        unit.totalArea > 0 && (React.createElement("span", { className: "zds-color-grey zds-body-lg real-estate__top-features" },
                            React.createElement(ZdsIcon, { class: "zds-margin-right-2", name: "aspect_ratio", slot: "icon", size: "md" }),
                            unit.totalArea,
                            " m\u00B2\u00A0",
                            React.createElement(Translation, { item: "tx_zigrealestate.surfaceArea" }))))),
                React.createElement("div", { className: "zds-row zds-gap-3 md:zds-gap-0" },
                    React.createElement("div", { className: "md:zds-col-6" },
                        unit.type == 1 && unit.sellingPrice > 0 && priceHeaderBuy(),
                        unit.type != 1 && (unit.netRent > 0 || unit.grossRent > 0) && priceHeaderRent()),
                    React.createElement(Reaction, { unit: unit })),
                React.createElement(ZdsDivider, { className: "zds-margin-y-4 md:zds-margin-y-8" }),
                (unit.introduction || unit.description) && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "real-estate__property-group" },
                        React.createElement("dl", { className: "md:zds-flex" },
                            React.createElement("dt", null,
                                React.createElement("h2", { className: "zds-headline-md zds-margin-bottom-2" },
                                    React.createElement(Translation, { item: "tx_zigrealestate.list.description" }))),
                            React.createElement("dd", null,
                                React.createElement("div", null,
                                    React.createElement(ZdsContentReveal, { closedText: renderToString(React.createElement(Translation, { item: "tx_zigrealestate.readMore" })), openText: renderToString(React.createElement(Translation, { item: "tx_zigrealestate.less" })) },
                                        unit.introduction && React.createElement("p", { className: "zds-bold" }, unit.introduction),
                                        unit.description && (React.createElement("p", { dangerouslySetInnerHTML: { __html: unit.description } }))))))),
                    React.createElement(ZdsDivider, { className: "zds-margin-y-4 md:zds-margin-y-8" }))),
                React.createElement(ResourcesList, { title: "tx_zigrealestate_domain_model_rentableunit.floorplans", resources: unit.floorplans.map((floorplan) => {
                        return { name: floorplan.name, url: floorplan.url };
                    }) }),
                React.createElement(ResourcesList, { title: "tx_zigrealestate.project.brochures", resources: unit.brochures.map((brochure) => {
                        return { name: brochure.name, url: brochure.url };
                    }) }),
                React.createElement(SpecificationList, { bottomDivider: !(unit.latitude && unit.longitude), title: "tx_zigrealestate.list.properties", specifications: [
                        { key: 'tx_zigrealestate.city', value: unit.city },
                        { key: 'tx_zigrealestate.quarter', value: unit.quarter },
                        { key: 'tx_zigrealestate.municipality', value: unit.municipality },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.postal_code',
                            value: unit.postalCode,
                            format: Formats.postalCode,
                        },
                        {
                            key: 'tx_zigrealestate.details.numberOfRooms',
                            value: unit.numberOfRooms,
                        },
                        {
                            key: 'tx_zigrealestate.constructionName',
                            value: unit.constructionName,
                        },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.vhe',
                            value: unit.vhe,
                        },
                    ] })),
            React.createElement(Map, { latitude: unit.latitude, longitude: unit.longitude }),
            React.createElement("div", { className: "default-content" },
                React.createElement(SpecificationList, { title: "tx_zigrealestate.template_layout", specifications: [
                        {
                            key: 'tx_zigrealestate.areaPremises',
                            value: unit.areaPremises,
                            format: Formats.squareMeters,
                        },
                        {
                            key: 'tx_zigrealestate.details.areaLivingroom',
                            value: unit.areaLivingroom,
                            format: Formats.squareMeters,
                        },
                        {
                            key: 'tx_zigrealestate.bedroom.area',
                            value: unit.bedrooms.map((bedroom) => FormatUtility.format(bedroom.area, Formats.squareMeters) + ' '),
                        },
                        {
                            key: 'tx_zigrealestate.project.details.numberOfBedrooms',
                            value: unit.bedrooms.length,
                        },
                        { key: 'tx_zigrealestate.template_layout', value: unit.layout },
                    ] }),
                React.createElement(SpecificationList, { title: "tx_zigrealestate.facilities", specifications: [
                        {
                            key: 'tx_zigrealestate.details.bicycleStorage',
                            value: yesNoField(unit.hasBicycleStorage),
                        },
                        { key: 'tx_zigrealestate.behindArea', value: unit.behindArea },
                        { key: 'tx_zigrealestate.storage', value: unit.storage },
                        {
                            key: 'tx_zigrealestate.details.hasElevator',
                            value: yesNoField(unit.hasElevator),
                        },
                        { key: 'tx_zigrealestate.parkingAvailability', value: unit.parking },
                        { key: 'tx_zigrealestate.outsideArea', value: unit.outsideArea },
                        {
                            key: 'tx_zigrealestate.outsideAreaLocation',
                            value: unit.outsideAreaLocation,
                        },
                    ] }),
                React.createElement(SpecificationList, { title: "tx_zigrealestate.details.build", specifications: [
                        {
                            key: 'tx_zigrealestate.details.buildingType',
                            value: parseTernaryBoolean(unit.isNewlyBuilt) === true ? (React.createElement(Translation, { item: "tx_zigrealestate.details.newBuilding" })) : parseTernaryBoolean(unit.isNewlyBuilt) === false ? (React.createElement(Translation, { item: "tx_zigrealestate.details.existingBuilding" })) : null,
                        },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.type',
                            value: unit.houseType,
                        },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.bat_code',
                            value: unit.batCode,
                            format: Formats.batCode,
                        },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.construction_year',
                            value: unit.constructionYear,
                        },
                        { key: 'tx_zigrealestate.details.heating', value: unit.heating },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.energy_label',
                            value: unit.energyLabel,
                        },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.floor_number',
                            value: unit.floorNumber,
                        },
                        {
                            key: 'tx_zigrealestate.details.amountOfFloors',
                            value: unit.numberOfFloors,
                        },
                    ] }),
                React.createElement(SpecificationList, { title: unit.type == 1
                        ? 'tx_zigrealestate.details.extraCosts'
                        : 'tx_zigrealestate.details.rentStructure', specifications: [
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.net_rent',
                            value: unit.netRent,
                            format: Formats.currency,
                        },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.gross_rent',
                            value: unit.grossRent,
                            format: Formats.currency,
                        },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.eligible_rent',
                            value: unit.eligibleRent,
                            format: Formats.currency,
                        },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.selling_price',
                            value: unit.sellingPrice,
                            format: Formats.buyPrice,
                            suffix: unit.buyerPaysCosts === 1 ? 'k.k.' : '',
                        },
                        {
                            key: 'tx_zigrealestate.details.serviceCosts',
                            value: unit.serviceCosts,
                            format: Formats.currency,
                        },
                    ] }),
                showHousingCosts && React.createElement(HousingCosts, { unit: unit }),
                React.createElement(SpecificationList, { title: "tx_zigrealestate.details.availability", specifications: [
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.available_from',
                            value: unit.availableFrom,
                            format: Formats.dateTime,
                        },
                        {
                            key: 'tx_zigrealestate_domain_model_rentableunit.available_to',
                            value: unit.availableTo,
                            format: Formats.dateTime,
                        },
                        { key: 'tx_zigrealestate.ownership', value: unit.ownership },
                    ] }),
                React.createElement(SpecificationList, { title: "tx_zigrealestate.terms", specifications: [
                        { key: 'tx_zigrealestate.targetGroup', value: unit.targetGroup },
                        { key: 'tx_zigrealestate.household', value: unit.conditionsFamily },
                        { key: 'tx_zigrealestate.income', value: unit.conditionsSalary },
                        { key: 'tx_zigrealestate.age', value: unit.conditionsAge },
                        {
                            key: 'tx_zigrealestate.regionBinding',
                            value: unit.conditionsRegionLinked,
                        },
                    ] }),
                React.createElement(ContactList, { title: "tx_zigrealestate.contacts", contacts: unit.contacts }),
                React.createElement(Contact, { title: "tx_zigrealestate.project.broker", contact: unit.broker }),
                shareThisPageConfiguration && shareThisPageConfiguration.platforms.length > 0 && (React.createElement(React.Fragment, null,
                    React.createElement(ShareThisPage, { title: unit === null || unit === void 0 ? void 0 : unit.name }),
                    React.createElement(ZdsDivider, { className: "zds-margin-y-4 md:zds-margin-y-8" }))),
                React.createElement(BackButton, null))));
    }
};
export default Detail;
